<div class="p-dialog-header">
  <div class="p-d-flex p-dialog-title">
    <i class="pi pi-warning p-mr-2" style="align-self: center;"></i>
    {{
      title === ""
        ? ("SigvLibrary.SystemNotification" | translate)
        : (title || "" | translate)
    }}
  </div>
  <div class="p-dialog-header-icons">
    <button
      type="button"
      tabindex="-1"
      class="p-dialog-header-icon p-dialog-header-close p-link p-ripple"
      (click)="close()"
    >
      <span class="p-dialog-header-close-icon pi pi-close"></span
      ><span class="p-ink"></span>
    </button>
  </div>
</div>
<div class="p-dialog-content">
  <div class="p-grid">
    <div class="p-col-12">
      <div
        *ngFor="let item of errors; let index = index"
        class="p-d-flex p-jc-between dialog-format-error"
        [ngStyle]="{ 'border-width.px': (index == lastIndex) ? 0 : 1}"
      >
        <label class="p-col text p-p-0 p-d-flex p-ai-center">
          {{ item.description }}
        </label>
        <label
          *ngIf="!!item.errorMessage"
          class="p-col p-error p-p-0 p-d-flex p-ai-center p-jc-end"
          [ngClass]="{'p-error': item.errorMessage !== ('SigvLibrary.Success' | translate)}"
        >
          {{ item.errorMessage }}
        </label>
      </div>
    </div>
  </div>
</div>
<div class="p-dialog-footer">
  <div class="p-d-flex p-jc-center">
    <div class="button pv-0 ph-0">
      <ng-container *ngIf="!hasAnyErrorMessage && questionButton; else oneButton">
        <button
          pButton
          type="button"
          [label]="'SigvLibrary.Cancel' | translate"
          class="p-button-secondary p-content-button p-mr-2"
          (click)="close('cancel')"
        ></button>
        <button
          pButton
          type="button"
          [label]="'SigvLibrary.Ok' | translate"
          class="p-content-button"
          (click)="close('ok')"
        ></button>
      </ng-container>
      <ng-template #oneButton>
        <button
          pButton
          type="button"
          [label]="'SigvLibrary.Ok' | translate"
          class="p-content-button"
          (click)="close()"
        ></button>
      </ng-template>
    </div>
  </div>
</div>
<div class="p-resizable-handle"></div>
